import { render, staticRenderFns } from "./InvestmentFeeScheduleSettings.vue?vue&type=template&id=b9a4223e&scoped=true"
import script from "./InvestmentFeeScheduleSettings.vue?vue&type=script&lang=ts"
export * from "./InvestmentFeeScheduleSettings.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentFeeScheduleSettings.vue?vue&type=style&index=0&id=b9a4223e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a4223e",
  null
  
)

export default component.exports